module.exports = __webpack_public_path__ + "img/bulma.e0eab74d.png";